














import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop, Watch } from 'vue-property-decorator';

import { GenealogyPerson } from '@/models/Genealogy';

@Component
export default class GenealogyPersonPreview extends Vue
{
    @Prop({ type: GenealogyPerson }) readonly person!: GenealogyPerson;
    @Prop({ type: Function }) readonly selected!: Function;

    get name()
    {
        return this.person.long_name || `${this.person.first_name} ${this.person.last_name}`;
    }

    get image()
    {
        return this.person.photo;
    }

    get birth()
    {
        return ((this.person.birth_date != null) ? this.person.birth_date.toLocaleDateString() : null);
    }

    get death()
    {
        return ((this.person.death_date != null) ? this.person.death_date.toLocaleDateString() : null);
    }

    get location()
    {
        return this.person.birth_location;
    }
}
